import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import { URL_LPS } from '../../settings/constants/login';

const FooterText = () => {
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isCompactDisplay = viewportHeight < 700 || viewportWidth <= 767;

  return (
    <>
      <div className="overlay--footer-text" />
      {isCompactDisplay ? (
        <div className="footer-content compact">
          <div className="tc footer-text">
            <FormattedMessage id="login.footer.textOne" />
            <br />
            <FormattedMessage id="login.footer.textTwo" />
            &nbsp;
            <a href={URL_LPS} target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
              <FormattedMessage id="login.footer.clickHere" />
            </a>
          </div>
        </div>
      ) : (
        <div className="footer-content">
          <div className="tc footer-text">
            <FormattedMessage id="login.footer.textOne" />
          </div>
          <div className="tc footer-text">
            <FormattedMessage id="login.footer.textTwo" />
            &nbsp;
            <a href={URL_LPS} target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
              <FormattedMessage id="login.footer.clickHere" />
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default FooterText;
